import { render, staticRenderFns } from "./EditGroupsV2.vue?vue&type=template&id=1d13114f&scoped=true&"
import script from "./EditGroupsV2.vue?vue&type=script&lang=js&"
export * from "./EditGroupsV2.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupsV2.vue?vue&type=style&index=0&id=1d13114f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13114f",
  null
  
)

export default component.exports